import Clients1 from "./Clients1";

const clients = {
    1: Clients1
};

export default clients;